import { Component } from '@angular/core';
import { PageUrls } from 'src/app/helpers/page-urls';

@Component({
    selector: 'app-user-navigation',
    templateUrl: './user-navigation.component.html',
    styleUrls: ['./user-navigation.component.scss']
})
export class UserNavigationComponent {

    get urls() {
        return PageUrls;
    }
}
